var render = function render(){var _vm=this,_c=_vm._self._c;return _c('skeleton-el',{class:{ 'skeleton-box': !_vm.imgLoaded },style:({ height: _vm.height, width: _vm.computedWidth, paddingTop: _vm.paddingTop })},[(_vm.image)?_c('img',{attrs:{"src":_vm.image,"alt":_vm.alt},on:{"load":_vm.onImgLoad,"error":_vm.$changeDefaultImage}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }